'use client';

import { Grid, Typography } from '@mui/material';
import CategoryCard from '../components/CategoryCard';
import DesignServicesIcon from '@mui/icons-material/DesignServices';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import { Box } from '@mui/material';

interface DisciplineStepProps {
  selectedDiscipline: string | null;
  onSelect: (discipline: string) => void;
}

const disciplines = [
  {
    id: 'design',
    label: 'Design',
    description: 'Need help with product design, 3D modeling, or technical drawings',
    icon: DesignServicesIcon,
  },
  {
    id: 'manufacturing',
    label: 'Manufacturing',
    description: '3D printing, CNC machining, laser cutting, and other manufacturing services',
    icon: PrecisionManufacturingIcon,
  },
];

export default function DisciplineStep({ selectedDiscipline, onSelect }: DisciplineStepProps) {
  return (
    <div>
      <Typography variant="h5" gutterBottom>
        What type of service do you need?
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Choose whether you need design services or manufacturing services
      </Typography>

      <Grid container spacing={3}>
        {disciplines.map(discipline => (
          <Grid item xs={12} sm={6} key={discipline.id}>
            <CategoryCard
              id={discipline.id}
              label={discipline.label}
              description={discipline.description}
              selected={selectedDiscipline === discipline.id}
              onClick={onSelect}
            />
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                mt: 2,
                color: 'text.secondary',
              }}
            >
              {discipline.icon && <discipline.icon sx={{ fontSize: 40 }} />}
            </Box>
          </Grid>
        ))}
      </Grid>
    </div>
  );
}
